import { AuthUser } from "../model/auth-user";
export interface AuthState {
    user: AuthUser;
    loggedIn: boolean;
    error: any;
    pending: boolean;
    errorCode: string;
    isInviteCodeValid: boolean;
}

export const initialAuthState: AuthState = {
    user: null,
    loggedIn: false,
    error: null,
    pending: true,
    errorCode: null,
    isInviteCodeValid: null,
};
